module.exports = __webpack_public_path__ + "static/rocketpc-5d0a89982a9d9444b14dab90fbb0c511.png";